import React, { PureComponent } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import DropZone from 'react-dropzone';
import Papa from 'papaparse';
import moment from 'moment-timezone';
import { validateWebUrl, addTransferProtocol, DL_DRIVE_REGEX } from 'appSrc/utils';
import { YOUTUBE_URI_REGEX, FACEBOOK_URI_REGEX } from 'appSrc/utils/video';
import style from './styles/style.module.css';

const timeCheck = /^\d?\d:\d\d(?:\:\d\d)? (?:(AM)|(PM))/i;

class CSVDropZone extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            working: false,
            errors: {},
        };
    }
    onDrop = ( files ) => {
        this.setState( { working: true } );
        if( files.length == 0 ) {
            this.setState( { error: 'No files detected.' } );
            return;
        }
        if( files.length > 1 ) {
            this.setState( { error: 'Only one file may be uploaded at a time.' } );
            return;
        }
        return Papa.parse( files[ 0 ], {
            header: true,
            skipEmptyLines: 'greedy',
            complete: ( results ) => {
                this.submitHandler( this.convertToStandard( results.data ) );
            },
            error: ( err ) => {
                console.error( err );
                alert( 'Unable to parse file!\nPlease make changes try a different file.' );
                this.setState( { working: false } );
            },
        } );
    }
    convertToStandard = ( rows ) => {
        const { runDate } = this.props;
        var runDateStr = runDate ? runDate.format( 'MM/DD/YYYY' ) : null;
        var standard = [];
        for( var i = 0; i < rows.length; i++ ) {
            var row = rows[ i ];

            if( row[ 'Link to Video' ] == '' ) {
                continue;
            }


            var newObj = { id: `csv-${ i }`, errors: {} };
            var dateStr = runDateStr || row[ 'Run Date' ];
            // parse start time
            if( timeCheck.test( row[ 'Start Time (CST)' ] ) ) {
                newObj.st = moment.tz( `${ dateStr } ${ row[ 'Start Time (CST)' ] }`, 'L LT', 'America/Chicago' );
                newObj[ 'start_time' ] = newObj.st.utc().toISOString();
            } else {
                newObj[ 'start_time' ] = newObj.st = moment( dateStr, 'L', 'America/Chicago' );
                newObj.errors[ 'start_time' ] = 'Failed to parse Start Time';
            }
            // parse end time
            if( timeCheck.test( row[ 'Expected End Time (CST)' ] ) ) {
                newObj.et = moment.tz( `${ dateStr } ${ row[ 'Expected End Time (CST)' ] }`, 'L LT', 'America/Chicago' );
                newObj[ 'end_time' ] = newObj.et.utc().toISOString();
            } else {
                newObj[ 'end_time' ] = newObj.et = moment( dateStr, 'L', 'America/Chicago' );
                newObj.errors[ 'end_time' ] = 'Failed to parse End Time';
            }

            // category is fine
            newObj[ 'category' ] = row[ 'Category' ];

            // convert "No Touch!!" to a true/false value (default is true)
            newObj[ 'should_persist' ] = row[ 'No Touch!!' ] == '' ? true : false;

            // add dontion link and make sure it is valid
            newObj[ 'donation_link' ] = row[ 'Donation Link' ] || undefined;
            if( newObj[ 'donation_link' ] ) {
                newObj[ 'donation_link' ] = addTransferProtocol( newObj[ 'donation_link' ] );
                if( !validateWebUrl( newObj[ 'donation_link' ] ) ) {
                    newObj.errors[ 'donation_link' ] = 'Donation Link is invalid';
                }
            }

            //sponser is fine
            newObj[ 'sponser' ] = row[ 'Sponser' ] || undefined;

            newObj[ 'sponser_link' ] = row[ 'Sponser Link' ] || undefined;
            // double check sponser link for errors
            if( newObj[ 'sponser_link' ] ) {
                newObj[ 'sponser_link' ] = addTransferProtocol( newObj[ 'sponser_link' ] );
                if( !validateWebUrl( newObj[ 'sponser_link' ] ) ) {
                    newObj.errors[ 'sponser_link' ] = 'Sponser Link is invalid';
                }
            }

            var video = {};
            video[ 'title' ] = row[ 'Title' ];

            video[ 'uri' ] = row[ 'Link to Video' ];
            if( !video[ 'uri' ] ) {
                newObj.errors[ 'video__uri' ] = 'Video Link is required';
            } else {
                video[ 'uri' ] = addTransferProtocol( video[ 'uri' ] );
                if( !validateWebUrl( video[ 'uri' ] ) ) {
                    newObj.errors[ 'video__uri' ] = 'Video Link is invalid';
                }else if( YOUTUBE_URI_REGEX.test( video[ 'uri' ] ) ) {
                    video[ 'source' ] = 'youtube';
                } else if( FACEBOOK_URI_REGEX.test( video[ 'uri' ] ) ) {
                    video[ 'source' ] = 'facebook';
                } else {
                    newObj.errors[ 'video__uri' ] = 'Video Link doesn\'t match expected patterns';
                }
            }

            video[ 'duration' ] = row[ 'Duration' ];

            video[ 'cover_image' ] = row[ 'Cover Image' ];
            // convert conver image, if it needs it
            if( DL_DRIVE_REGEX.test( video[ 'cover_image' ] ) ) {
                var id = video[ 'cover_image' ].match( DL_DRIVE_REGEX )[ 1 ];
                video[ 'cover_image' ] = 'https://drive.google.com/a/desirelist.com/thumbnail?id=' + id;
            }

            video[ 'pro_name' ] = ( row[ 'Pro/Presenter' ] || '' ).trim();

            video[ 'pro_profession' ] = ( row[ 'Pro Title' ] || '' ).trim();

            video[ 'pro_email' ] = ( row[ 'Pro Email' ] || '' ).trim();

            video[ 'description' ] = row[ 'Description' ];

            // convert Live/Taped data to boolean
            video[ 'is_live' ] = /^LIVE/.test( row[ 'LIVE or Pre-Taped' ] ) ? true : false;

            video[ 'related_content_link' ] = row[ 'Related Content Link' ];
            if( video[ 'related_content_link' ] ) {
                video[ 'related_content_link' ] = addTransferProtocol( video[ 'related_content_link' ] );
                if( !validateWebUrl( video[ 'related_content_link' ] ) ) {
                    newObj.errors[ 'video__related_content_link' ] = 'Related Content Link is invalid';
                }
            }

            newObj[ 'video' ] = video;

            standard.push( newObj );
        }
        return standard;
    }
    submitHandler = ( values ) => {
        this.setState( { working: false } );
        this.props.onSubmit( values );
    }



    render() {
        const { working } = this.state;


        return (
            <DLModal title='Import CSV' className={ style.csvModal } visible={ this.props.visible }
            closeHandler={ this.props.closeHandler } data-working={ working }>
                <div>
                    <DropZone onDrop={ this.onDrop }>
                        { ( {getRootProps, getInputProps} ) => (
                            <section className={ style.dropZone }>
                                <div { ...getRootProps() }>
                                    <input { ...getInputProps() } />
                                    <p>Drag &amp; drop some files here, or click&nbsp;to&nbsp;select&nbsp;files</p>
                                </div>
                            </section>
                        ) }
                    </DropZone>
                </div>
                { working &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
CSVDropZone.defaultProps = {
    onSubmit: () => {},
};

export default CSVDropZone;
